export var SlackFeature;
(function (SlackFeature) {
    SlackFeature["SCHEDULED_DELIVERIES"] = "scheduledDeliveries";
    SlackFeature["CUSTOM_APP_PROFILE"] = "customAppProfile";
    SlackFeature["LINK_UNFURLING"] = "linkUnfurling";
    SlackFeature["WRITEBACK_REACTIONS"] = "writebackReactions";
    SlackFeature["AI_AGENT"] = "aiAgent";
})(SlackFeature || (SlackFeature = {}));
export const SLACK_FEATURE_SCOPES = {
    [SlackFeature.SCHEDULED_DELIVERIES]: {
        scopes: [
            'chat:write',
            'files:write',
            'files:read',
            'channels:read',
            'groups:read',
            'users:read',
        ],
        commercialScopes: [],
    },
    [SlackFeature.CUSTOM_APP_PROFILE]: {
        scopes: ['chat:write.customize'],
        commercialScopes: [],
    },
    [SlackFeature.LINK_UNFURLING]: {
        scopes: ['links:read', 'links:write'],
        commercialScopes: [],
    },
    [SlackFeature.WRITEBACK_REACTIONS]: {
        scopes: ['reactions:write'],
        commercialScopes: [],
    },
    [SlackFeature.AI_AGENT]: {
        scopes: [
            'app_mentions:read',
            'chat:write',
            'users:read',
            'files:read',
            'files:write',
        ],
        commercialScopes: ['channels:history', 'groups:history'],
    },
};
const getFeatureScopes = (feature, isCommercial) => {
    const { scopes, commercialScopes } = SLACK_FEATURE_SCOPES[feature];
    return isCommercial ? [...scopes, ...commercialScopes] : scopes;
};
export const getSlackInstallScopes = (isCommercial) => Array.from(new Set(Object.values(SlackFeature).flatMap((feature) => getFeatureScopes(feature, isCommercial))));
const getAvailability = (granted, feature, isCommercial) => {
    const missingScopes = getFeatureScopes(feature, isCommercial).filter((scope) => !granted.has(scope));
    return { available: missingScopes.length === 0, missingScopes };
};
export const getSlackFeatureAvailability = (grantedScopes, isCommercial) => {
    const granted = new Set(grantedScopes ?? []);
    return {
        scheduledDeliveries: getAvailability(granted, SlackFeature.SCHEDULED_DELIVERIES, isCommercial),
        customAppProfile: getAvailability(granted, SlackFeature.CUSTOM_APP_PROFILE, isCommercial),
        linkUnfurling: getAvailability(granted, SlackFeature.LINK_UNFURLING, isCommercial),
        writebackReactions: getAvailability(granted, SlackFeature.WRITEBACK_REACTIONS, isCommercial),
        aiAgent: getAvailability(granted, SlackFeature.AI_AGENT, isCommercial),
    };
};
//# sourceMappingURL=slackSettings.js.map